import { createContext } from 'react';

/**
 * Правила результата экспертного заключения, у комментария которых есть версии, кроме действующей.
 *
 * Историю версий комментария карточка предлагает только им: пока версия одна, показывать нечего.
 * Перечень приходит вместе с результатом, а нужен в строке каждого правила глубоко в заключении,
 * поэтому раздаётся контекстом, а не по цепочке пропов.
 *
 * Значение по умолчанию — пустой перечень: не зная результата, экран истории не обещает.
 */
export const ExpertReportCommentHistoryRulesContext = createContext<ReadonlySet<number>>(new Set());
